import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ModalOverlayRef } from '../../modal-overlay-ref';
import { LanguageService } from "../../../core/services/language.service";

@Component({
    selector: 'gl-pro-info',
    templateUrl: './pro-info.component.html',
    styleUrls: ['./pro-info.component.scss'],
    standalone: false
})
export class ProInfoComponent {
  public message: string;
  public isMobile: boolean;

  constructor(
    private modalRef: ModalOverlayRef,
    private router: Router,
    private languageService: LanguageService
  ) {
    this.modalRef.backgroundClicked();
    this.isMobile = this.router.url.includes('mobile');
  }

  public close(result: boolean) {
    this.modalRef.close(result);
  }

  public openPriceList(): void {
    this.close(true);
    const defaultLanguage = this.languageService.getDefaultLanguage();
    this.router.navigateByUrl(`/${defaultLanguage}/account/subscription/priceList`);
  }
}
